// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'user-plus-solid';

export const Component = () => (
  <path d='M20.635 6.406h2.442c.335 0 .527.192.527.527s-.191.479-.527.479h-2.442v2.442c0 .335-.144.479-.479.479-.335 0-.479-.144-.479-.48v-2.44h-2.49c-.335 0-.48-.144-.48-.48 0-.334.145-.526.48-.526h2.49V3.964c0-.335.144-.479.48-.479.334 0 .478.144.478.48v2.441Zm-16.666.48c0-1.341.479-2.491 1.436-3.45C6.363 2.48 7.512 2 8.854 2c1.389 0 2.538.479 3.496 1.437.958.958 1.437 2.107 1.437 3.448 0 1.39-.48 2.538-1.437 3.496-.958.958-2.107 1.437-3.496 1.437-1.34 0-2.49-.479-3.449-1.437-.957-.958-1.436-2.107-1.436-3.496Zm4.885 5.89c2.155 0 4.023.766 5.555 2.299 1.533 1.533 2.3 3.4 2.3 5.555v.48c0 .335-.144.526-.48.526H1.528c-.336 0-.527-.191-.527-.527v-.479c0-2.155.766-3.975 2.3-5.507 1.58-1.58 3.4-2.347 5.555-2.347h-.001Z' />
);

export const viewBox = '0 0 25 25';
